
import Vue from 'vue'
import {
  ERROR_CODE_NETWORK
} from '@/constants/settings.js'
import { ERRORS } from '@/constants/store.js'

const state = {
  [ERRORS.STATE.GENERAL_ERROR]: null
}

const actions = {
  async [ERRORS.ACTIONS.SHOW_ERROR] ({ commit }, error) {
    commit(ERRORS.MUTATIONS.ERROR_RECEIVED, error)
  },
  async [ERRORS.ACTIONS.SHOW_AND_THROW_ERROR] ({ commit }, error) {
    const errorModel = Vue.helpers.getErrorDescription(error)
    if (Vue.getEnvironmentName() === 'development') {
    // eslint-disable-next-line no-console
      console.log(errorModel)
    }
    commit(ERRORS.MUTATIONS.ERROR_RECEIVED, errorModel)

    if (error?.status === ERROR_CODE_NETWORK) {
      throw new Vue.errorsTypes.NetworkError(error)
    }
    throw new Vue.errorsTypes.ServerError()
  },
  async [ERRORS.ACTIONS.HIDE_ERROR] ({ commit }) {
    commit(ERRORS.MUTATIONS.ERROR_CLEAR)
  }
}

const mutations = {
  [ERRORS.MUTATIONS.ERROR_RECEIVED] (state, error) {
    state[ERRORS.STATE.GENERAL_ERROR] = error
  },
  [ERRORS.MUTATIONS.ERROR_CLEAR] (state) {
    state[ERRORS.STATE.GENERAL_ERROR] = null
  }
}

export default {
  state,
  actions,
  mutations
}
